// extracted by mini-css-extract-plugin
module.exports = {"text":"text__2rAMp","multiline":"multiline__1Ck6I"};